import { findElementByIdInShadowDom } from './utils/render.js';
import { renderMap, filterMap } from './pointsMap.js';
import { json } from 'd3-fetch';
import { colors } from './maputils/colors';
import { defaultMetal, metalsList } from './maputils/metals';

window.onload = function () {
  const palisadesMap = findElementByIdInShadowDom('palisades-map');
  const altadenaMap = findElementByIdInShadowDom('altadena-map');

  // generate legend
  const circleLegend = findElementByIdInShadowDom('circle-legend-items');
  const values = [
    'Less than half the health-based standard',
    'Up to the standard',
    '1 to 2 times above',
    '2 to 3 times',
    'More than 3 times',
  ];
  function setCircleColor(ele, i, metal) {
    ele.style['background-color'] = colors[metal][i];
  }

  values.forEach((val, i) => {
    // legend item container
    const row = document.createElement('div');
    row.className = 'item';

    // make a circle
    const c = document.createElement('span');
    c.className = `circle c${i}`;
    setCircleColor(c, i, defaultMetal);

    const label = document.createElement('p');
    label.className = 'label';
    label.textContent = val;

    row.appendChild(c);
    row.appendChild(label);
    circleLegend.appendChild(row);
  });

  let legendItems = Array.from(circleLegend.children);

  // build dropdown
  const dropdown = findElementByIdInShadowDom('metal-selector');

  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  metalsList.forEach((d) => {
    const option = document.createElement('option');
    option.value = d;
    option.text = capitalize(d);
    dropdown.append(option);
  });

  async function main() {
    // import reports dictionary
    const reportsURL = new URL('../_data/report-urls.json', import.meta.url);
    const reportsData = await json(reportsURL);

    let palisadesMapBox = await renderMap(palisadesMap, reportsData);
    let altadenaMapBox = await renderMap(altadenaMap, reportsData);

    dropdown.addEventListener('change', (event) => {
      let selectedMetal = event.target.value;

      legendItems.forEach((item, i) => {
        let c = item.querySelector('.circle');
        setCircleColor(c, i, selectedMetal);
      });

      filterMap(selectedMetal, palisadesMapBox, palisadesMap);
      filterMap(selectedMetal, altadenaMapBox, altadenaMap);
    });
  }

  main().catch(console.error);
};
